import { render, staticRenderFns } from "./ManagementPage.vue?vue&type=template&id=e4ad70c6&scoped=true&"
import script from "./ManagementPage.vue?vue&type=script&lang=js&"
export * from "./ManagementPage.vue?vue&type=script&lang=js&"
import style0 from "./ManagementPage.vue?vue&type=style&index=0&id=e4ad70c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ad70c6",
  null
  
)

export default component.exports